import { Observable, catchError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { GetPortsResponse } from '@navstation-portal/ports/data-model/ports';
import { ApiErrorMapper, BASE_API_URL } from '@navstation-portal/shared/util/api';

@Injectable({
  providedIn: 'root',
})
export class PortsService {
  private http = inject(HttpClient);
  private readonly baseUrl = inject(BASE_API_URL);
  private apiError = inject(ApiErrorMapper).forFeature('Ports');

  getPorts(): Observable<GetPortsResponse> {
    return this.http
      .get<GetPortsResponse>(`${this.baseUrl}/v1/ports/detailed`)
      .pipe(catchError(this.apiError.toApiError('getting ports')));
  }
}
